<template>
  <IdentifySelect previous-page-id="mb038" next-page-id="mb036">
    <template #wizard>
      <MainWizard
        :active-index="1"
        type="useridentity"
        class="_mb-sm-35 _mb-md-50"
      ></MainWizard>
    </template>
  </IdentifySelect>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IdentifySelect from "@/components/fileupload/IdentifySelect";
import MainWizard from "@/components/wizard/MainWizard";

export default {
  name: "Mb035",
  components: {
    MainWizard,
    IdentifySelect,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,本人確認書類",
    });
  },
};
</script>

<style lang="scss" scoped></style>
